<div class="qb-page-content p-input-filled" id="topLevel">
  <p-blockui [blocked]="parent?.isPageReady && parent?.isBusy()">
    <div class="progress-spinner">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </p-blockui>
  <div *ngIf="!parent?.isPageReady" class="loading-center">
    <p-progressSpinner ariaLabel="center" />
  </div>
  <div *ngIf="parent?.isPageReady" class="flex flex-col grow min-h-0">
    <fieldset class="qb-page-body" [disabled]="isDisabled">
      <ng-container *ngTemplateOutlet="bodyTemplate ? bodyTemplate : defaultBody"></ng-container>
    </fieldset>
    <div class="flex-shrink-0">
      <ng-container *ngTemplateOutlet="footerTemplate ? footerTemplate : defaultFooter"></ng-container>
    </div>
  </div>
</div>
<!-- Centralized confirm dialogs - no need to add p-confirmDialog in individual components -->
<p-confirmDialog [closable]="false" [baseZIndex]="999"></p-confirmDialog>

<ng-template #defaultBody></ng-template>
<ng-template #defaultFooter>
  <div *ngIf="showBack || !parent?.hasMethod('hasChanges')" class="qb-page-footer">
    <button (click)="parent?.navigateBack()" pButton type="button" icon="pi pi-backward" label="Go Back"
      class="p-button-raised"></button>
  </div>
</ng-template>